var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.527 13.8066C11.6991 13.8857 11.893 13.9037 12.0767 13.8578C12.2605 13.8119 12.4231 13.7048 12.5378 13.5541L12.8337 13.1666C12.9889 12.9596 13.1902 12.7916 13.4216 12.6759C13.6531 12.5602 13.9083 12.5 14.167 12.5H16.667C17.109 12.5 17.5329 12.6756 17.8455 12.9881C18.1581 13.3007 18.3337 13.7246 18.3337 14.1666V16.6666C18.3337 17.1087 18.1581 17.5326 17.8455 17.8451C17.5329 18.1577 17.109 18.3333 16.667 18.3333C12.6887 18.3333 8.87344 16.7529 6.06039 13.9399C3.24734 11.1268 1.66699 7.31154 1.66699 3.33329C1.66699 2.89127 1.84259 2.46734 2.15515 2.15478C2.46771 1.84222 2.89163 1.66663 3.33366 1.66663H5.83366C6.27569 1.66663 6.69961 1.84222 7.01217 2.15478C7.32473 2.46734 7.50033 2.89127 7.50033 3.33329V5.83329C7.50033 6.09203 7.44008 6.34722 7.32437 6.57865C7.20866 6.81007 7.04065 7.01138 6.83366 7.16663L6.44366 7.45913C6.29067 7.57594 6.18284 7.74211 6.13848 7.92942C6.09413 8.11672 6.11598 8.31361 6.20033 8.48663C7.33923 10.7998 9.21235 12.6706 11.527 13.8066Z",
    stroke: "#90A1B9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneContact);
export default __webpack_public_path__ + "static/media/phone-contact.a6e4f490cc56dbb4b68f907335dc7a27.svg";
export { ForwardRef as ReactComponent };